// mtdTest.tsx - Test page for debugging MTD data loading
import { useEffect, useState } from 'react';
import { useApiData } from '../../contexts/apiService';
import { useDataManager } from '../../contexts/dataManager';
import './mainMTDPage.css';

const MTDTestPage = () => {
    const { apiData } = useApiData();
    const { requestTableData, hasTableData, isGetTableLoading } = useDataManager();
    const [requestLog, setRequestLog] = useState<string[]>([]);

    const addLog = (message: string) => {
        setRequestLog(prev => [...prev, `${new Date().toLocaleTimeString()}: ${message}`]);
    };

    useEffect(() => {
        addLog('Component mounted');
    }, []);

    const handleRequestTable = (tableName: string, month?: string) => {
        addLog(`Requesting ${tableName}${month ? ` for ${month}` : ''}`);
        requestTableData(tableName, month);
    };
    useEffect(() => {
        if(apiData){
            console.log("API Data Changed: ", apiData);
            console.log("Crude Main Sample: ", apiData.date_ranges.crude_main);
        }

        },[apiData?.date_ranges]);
    const testTables = [
        'date_ranges',
        'main_table',
        'bottoms_main_table',
        'ngl_schedule_table',
        'components_pricing',
    ];

    return (
        <div style={{ padding: '20px', fontFamily: 'monospace' }}>
            <h1>MTD Data Loading Test Page</h1>
            
            <div style={{ marginBottom: '20px' }}>
                <h2>Loading Status</h2>
                <p>isGetTableLoading: <strong>{isGetTableLoading ? 'TRUE' : 'FALSE'}</strong></p>
            </div>

            <div style={{ marginBottom: '20px' }}>
                <h2>Tables Status</h2>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <thead>
                        <tr style={{ borderBottom: '2px solid #ccc' }}>
                            <th style={{ padding: '8px', textAlign: 'left' }}>Table Name</th>
                            <th style={{ padding: '8px', textAlign: 'left' }}>Has Data</th>
                            <th style={{ padding: '8px', textAlign: 'left' }}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {testTables.map(table => (
                            <tr key={table} style={{ borderBottom: '1px solid #eee' }}>
                                <td style={{ padding: '8px' }}>{table}</td>
                                <td style={{ padding: '8px' }}>
                                    <span style={{ 
                                        color: hasTableData(table) ? 'green' : 'red',
                                        fontWeight: 'bold'
                                    }}>
                                        {hasTableData(table) ? '✓ YES' : '✗ NO'}
                                    </span>
                                </td>
                                <td style={{ padding: '8px' }}>
                                    <button 
                                        onClick={() => handleRequestTable(table)}
                                        style={{ 
                                            padding: '4px 8px',
                                            marginRight: '8px',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        Request
                                    </button>
                                    {(table === 'main_table' || table === 'bottoms_main_table' || table === 'ngl_schedule_table') && (
                                        <button 
                                            onClick={() => handleRequestTable(table, 'December 2025')}
                                            style={{ 
                                                padding: '4px 8px',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            Request Dec 2025
                                        </button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div style={{ marginBottom: '20px' }}>
                <h2>API Data Structure</h2>
                <div style={{ 
                    background: '#f5f5f5', 
                    padding: '10px', 
                    borderRadius: '4px',
                    maxHeight: '300px',
                    overflow: 'auto'
                }}>
                    {apiData ? (
                        <div>
                            <p><strong>Available keys:</strong></p>
                            <ul>
                                {Object.keys(apiData).map(key => (
                                    <li key={key}>
                                        {key}: {Array.isArray(apiData[key as keyof typeof apiData]) 
                                            ? `Array[${(apiData[key as keyof typeof apiData] as any[]).length}]`
                                            : typeof apiData[key as keyof typeof apiData]
                                        }
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ) : (
                        <p>No API data loaded</p>
                    )}
                </div>
            </div>

            <div style={{ marginBottom: '20px' }}>
                <h2>date_ranges Structure</h2>
                <div style={{ 
                    background: '#f5f5f5', 
                    padding: '10px', 
                    borderRadius: '4px',
                    maxHeight: '200px',
                    overflow: 'auto'
                }}>
                    {apiData?.date_ranges ? (
                        <pre style={{ margin: 0 }}>
                            {JSON.stringify(apiData.date_ranges, null, 2)}
                        </pre>
                    ) : (
                        <p>date_ranges not loaded</p>
                    )}
                </div>
            </div>

            <div>
                <h2>Request Log</h2>
                <div style={{ 
                    background: '#f5f5f5', 
                    padding: '10px', 
                    borderRadius: '4px',
                    maxHeight: '300px',
                    overflow: 'auto',
                    fontSize: '12px'
                }}>
                    {requestLog.length > 0 ? (
                        <ul style={{ margin: 0, padding: '0 0 0 20px' }}>
                            {requestLog.map((log, i) => (
                                <li key={i}>{log}</li>
                            ))}
                        </ul>
                    ) : (
                        <p>No requests yet</p>
                    )}
                </div>
            </div>

            <div style={{ marginTop: '20px' }}>
                <h2>Console Output</h2>
                <p>Check the browser console for detailed logs from:</p>
                <ul>
                    <li>MTDDataWrapper</li>
                    <li>dataManager</li>
                    <li>apiService</li>
                </ul>
            </div>
        </div>
    );
};

export default MTDTestPage;
